module.exports = __webpack_public_path__ + "media/images/flags/bg-b0e59e45b564afb05ed8141b3672628c.svg";